<template>
  <div ref="wordCloud" class="Cloud" />
</template>

<script>
// https://github.com/makeupsomething/vue-d3-cloud
// https://www.jasondavies.com/wordcloud/
import * as d3 from 'd3'
import * as cloud from 'd3-cloud'
const defaultFill = d3.scaleOrdinal(d3.schemeCategory10)
export default {
  props: {
    data: {
      type: Array,
      required: true
    },
    fillMapper: {
      type: Function,
      default: (word, i) => defaultFill(i)
    },
    fontSizeMapper: {
      type: Function,
      required: true
    },
    onWordClick: {
      type: Function,
      default: word => {
        console.log('click', word)
      }
    },
    onWordOver: {
      type: Function,
      default: word => {
        console.log('over', word)
      }
    },
    onWordOut: {
      type: Function,
      default: word => {
        console.log('out', word)
      }
    },
    rotate: {
      type: [Function, String, Number],
      default: 0
    },
    font: {
      type: [String, Function],
      default: 'Serif'
    },
    width: {
      type: [Number, String],
      default: 960
    },
    height: {
      type: [Number, String],
      default: 500
    },
    padding: {
      type: [Number, String],
      default: 0
    },
    spiral: {
      type: String,
      default: 'archimedean'
    }
  },
  data() {
    return {
      layout: {},
      chart: {}
    }
  },

  watch: {
    width() {
      this.createCanvas()
    },
    height() {
      this.createCanvas()
    },
    data() {
      this.createCanvas()
    },
    rotate() {
      this.createCanvas()
    },
    font() {
      this.createCanvas()
    },
    padding() {
      this.createCanvas()
    },
    spiral() {
      this.createCanvas()
    }
  },

  mounted() {
    this.createCanvas()
  },

  methods: {
    updateColorFill() {
      d3.select(this.$el)
        .selectAll('text')
        .style('fill', this.fillMapper)
    },
    createCanvas() {
      const wordCounts = this.data.map(text => ({...text}))

      d3.select(this.$el)
        .selectAll('*')
        .remove()

      const layout = cloud()
        .size([this.width, this.height])
        .words(wordCounts)
        .padding(this.padding)
        .spiral(this.spiral)
        .rotate(this.rotate)
        .font(this.font)
        .fontSize(this.fontSizeMapper)
        .on('end', this.end)

      layout.start()
    },
    end(words) {
      this.$emit('cloudUpdated', words.length)
      d3.select(this.$el)
        .append('svg')
        .attr('width', this.width)
        .attr('height', this.height)
        .append('g')
        .attr('transform', `translate(${this.width / 2}, ${this.height / 2})`)
        .selectAll('text')
        .data(words)
        .enter()
        .append('text')
        .style('font-family', d => d.font)
        .style('font-size', d => {
          return `${d.size}px`
        })
        .style('fill', this.fillMapper)
        .style('cursor', 'pointer')
        .attr('text-anchor', 'middle')
        .attr('transform', d => {
          return `translate(${[d.x, d.y]}) rotate(${d.rotate})`
        })
        .text(d => d.text)
        .on('click', this.onWordClick)
        .on('mouseenter', this.onWordOver)
        .on('mouseleave', this.onWordOut)
    }
  }
}
</script>
